export default __webpack_public_path__ + "static/media/27.2f0c54bf.png";